import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import languageDetcor from "i18next-browser-languagedetector";
import translationEN from "./locale/en.json";
import translationAr from "./locale/ar.json";

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAr,
  },
};

// Get saved language from localStorage or default to "en"
const getInitialLanguage = (): string => {
  const savedLanguage = localStorage.getItem("i18nextLng");
  if (savedLanguage === "ar" || savedLanguage === "en") {
    return savedLanguage;
  }
  return "en";
};

// Apply lang + dir to <html> so CSS selectors like html[lang="ar"] and html[dir="rtl"] work
const applyDocumentLanguage = (lang: string) => {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};

// Set immediately on load (before React renders)
applyDocumentLanguage(getInitialLanguage());

i18n
  .use(languageDetcor)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Keep <html lang> and <html dir> in sync whenever the language changes at runtime
i18n.on("languageChanged", applyDocumentLanguage);

export default i18n;
